import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import { withRouter } from 'react-router-dom';

import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';

import { makeRowColumn } from 'lib/commonLib';

import NewButton from 'components/molecules/NewButton';

const useStyles = makeStyles((theme) => ({
  totalCell: {
    height: 42,
    boxSizing: 'border-box',
    backgroundColor: '#f6f6f9 !important',
    borderBottom: '1px solid #bfcace !important',
  },
  cell: {
    fontSize: 12,
    color: theme.palette.table.cell.black,
    backgroundColor: theme.palette.table.cell.default,
    borderBottom: theme.palette.box.border,
    '&:not(:last-child)': { borderRight: theme.palette.box.border },
    '&.MuiTableCell-sizeSmall': { padding: 5 },
    // 테이블 th, td 커스텀 css
    '& td.mb-corpName-text': {
      color: theme.palette.table.cell.blue,
      width: 120,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '& .black': { color: theme.palette.table.cell.black },
    '& .red, &.mb-advrtsAmt': { color: theme.palette.table.cell.red },
    '& .blue, &.mb-clickRate': { color: theme.palette.table.cell.blue },
    '& .green, &.mb-ecpm': { color: theme.palette.table.cell.green },
    '&.mb-mobRoas, &.mb-roas, &.mb-directRoas, &.mb-sessionRoas, &.mb-mobSessionRoas, &.mb-browserSessionRoas':
      { color: theme.palette.table.cell.purple },
    '& .gray': { color: theme.palette.table.cell.gray },
    '&.mb-ageRange div': {
      width: 100,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '&.mb-kpi div': {
      width: 100,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '&.mb-grpStr div': {
      width: 120,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '&.pointer': { cursor: 'pointer' },
    '&.mb-url': { maxWidth: 150, wordBreak: 'break-all' },
    '& p': { margin: 0 },
  },
  tableBodyRow: {
    height: '42px',
    '&:hover > td': {
      backgroundColor: theme.palette.table.cell.active,
      '&:first-child': {
        backgroundColor: theme.palette.table.cell.active,
      },
    },
    '& > td:first-child': {
      position: 'sticky',
      top: 0,
      left: 0,
      zIndex: theme.zIndex.table.sticky,
      padding: 10,
      backgroundColor: theme.palette.table.cell.default,
      borderRight: theme.palette.table.border.body,
      borderBottom: theme.palette.table.border.body,
    },
  },
  childCell: {
    '& > td': {
      backgroundColor: theme.palette.table.cell.child,
      '&:first-child': {
        backgroundColor: theme.palette.table.cell.child,
      },
    },
  },
  nonePName: { backgroundColor: 'yellow' },
  funcCell: { display: 'flex', alignItems: 'center' },
  expandRow: {
    background: 'transparent',
    borderRadius: '50%',
    cursor: 'pointer',
  },
  checkboxRoot: { padding: 0 },
}));

/**
 * 테이블 row 컴포넌트
 * @param {Object} props
 */
const MbTableRow = (props) => {
  const classes = useStyles();

  const {
    row,
    headCells,
    useCheckBox,
    pointer,
    handleClick,
    customized = {},
    expandTable,
    childColumnSet = {},
    // useFetch,
    dataDetailReqPromise,
    handleAddSubList,
    newSelected,
    useTotal = false,
    index,
    useRowData,
    handleRowData,
    rowColor,
  } = props;
  const { SUB: sub = [] } = row;
  const [selected, setSelected] = useState(false);
  const [open, setOpen] = useState(false);
  let num = 1;

  /**
   *  Head 체크박스 컨트롤 변경시 body 체크박스 컨트롤
   */
  useEffect(() => {
    setOpen(false);
  }, [row]);

  useEffect(() => {
    if (newSelected.includes(index)) {
      setSelected(true);
    } else {
      setSelected(false);
    }
  }, [newSelected, index]);

  /**
   * 체크박스 변경시
   */
  const getCheckValue = (e) => {
    handleClick(e);
    setSelected(!selected);
  };

  /**
   * row 한줄 만들기
   */
  const makeCell = useCallback(() => {
    const cell = [];
    for (let headCell of headCells.values()) {
      const {
        id: headId,
        align,
        format,
        type,
        className,
        isAddColumn = false,
        makeRowFunc,
      } = headCell;

      const isChild = row.isChild;
      let content = row[headId];
      let title = null;

      if (
        isChild !== true &&
        isAddColumn === false &&
        (typeof row[headId] === 'undefined' || headId === 'SEQ')
      ) {
        // header 에 있는 값만 body에 뿌려줌
        continue;
      }

      if (typeof makeRowFunc !== 'undefined') {
        // 화면에서 추가하는 column
        if (typeof customized[headId] !== 'undefined') {
          if (!!customized[headId]['makeBody']) {
            content = customized[headId].makeBody(row, headCells);
          } else {
            content = makeRowFunc(row);
          }
        } else {
          content = makeRowFunc(row);
        }
      } else {
        if (typeof customized[headId] !== 'undefined') {
          if (customized[headId].merged === true) {
            // 테이블 내용 합쳐진 경우
            continue;
          } else {
            if (!!customized[headId]['makeBody']) {
              content = customized[headId].makeBody(row, headCells);
            } else {
              content = makeRowColumn(content, type, format);
            }
          }
        } else {
          if (Object.keys(childColumnSet).length > 0) {
            //   세부사항 tr 이면서
            content = childColumnSet[headId]();
          } else {
            content = makeRowColumn(content, type, format);
            title = content;
          }
        }
      }
      let makeCellClass;
      if (useTotal) {
        makeCellClass = clsx(className, classes.cell, classes.totalCell);
      } else {
        makeCellClass = clsx({ pointer }, className, classes.cell);
      }
      if (typeof title === 'boolean') title = '';

      let hardStyle =
        customized[headId] !== undefined ? customized[headId].bodyStyle : null;

      if (typeof rowColor !== 'undefined') {
        const colorKey = row[rowColor['key']];
        const colorValue = rowColor[colorKey];
        hardStyle = { ...hardStyle, backgroundColor: colorValue };
      }
      cell.push(
        <TableCell
          style={hardStyle}
          title={title}
          className={makeCellClass}
          key={headId}
          align={align}
        >
          <div style={content === 'total' ? { fontWeight: 'bold' } : null}>
            {content}
          </div>
        </TableCell>
      );
    }
    return cell; // eslint-disable-next-line
  }, [headCells, row, customized, childColumnSet, useTotal, pointer]);

  /**
   * row sub 한줄 만들기
   */
  const makeSubCell = useCallback(() => {
    const subCells = [];
    const subLists = sub;
    for (let subList of subLists.values()) {
      const cell = [];
      cell.push(<TableCell key={index + '-cell'} className={classes.cell} />);
      for (let headCell of headCells.values()) {
        const { id: headId, align, format, type, makeRowFunc } = headCell;

        let content = subList[headId];
        let title = null;

        if (typeof makeRowFunc !== 'undefined') {
          // 화면에서 추가하는 column
          content = makeRowFunc(subList);
        } else {
          if (typeof customized[headId] !== 'undefined') {
            if (customized[headId].merged === true) {
              // 테이블 내용 합쳐진 경우
              continue;
            } else {
              if (!!customized[headId].makeBody) {
                content = customized[headId].makeBody(subList, headCells);
              } else {
                content = makeRowColumn(content, type, format);
              }
            }
          } else {
            content = makeRowColumn(content, type, format);
            title = content;
          }
        }

        cell.push(
          <TableCell
            style={
              customized[headId] !== undefined
                ? customized[headId].bodyStyle
                : null
            }
            title={title}
            className={clsx(classes.cell)}
            key={index + '-' + headId + '-' + subLists.indexOf(subList)}
            align={align}
          >
            {content}
          </TableCell>
        );
      }
      subCells.push(
        <TableRow
          key={index + '-sub-' + num++}
          className={clsx(classes.tableBodyRow, classes.childCell)}
        >
          {cell}
        </TableRow>
      );
    }

    return subCells; // eslint-disable-next-line
  }, [headCells, row, customized, childColumnSet, useTotal, pointer]);

  const handleExpendClick = () => {
    handleAddSubList(row);
    setOpen(!open);
  };

  return (
    <>
      <TableRow
        tabIndex={-1}
        key={index}
        data-key={index}
        style={row.display === false ? { display: 'none' } : null}
        className={clsx({ tableRow: true })}
        classes={{ root: classes.tableBodyRow }}
        onClick={useRowData ? handleRowData : (f) => f}
      >
        {useCheckBox || expandTable ? (
          <TableCell
            className={clsx(classes.cell)}
            classes={{
              root: useTotal && classes.totalCell,
            }}
            style={{ textAlign: 'center' }}
          >
            <div className={classes.funcCell}>
              {useCheckBox && !useTotal && (
                <div>
                  <Checkbox
                    classes={{ root: classes.checkboxRoot }}
                    checked={selected}
                    onChange={getCheckValue}
                    color="primary"
                    inputProps={{ 'data-key': index }}
                  />
                </div>
              )}
              {expandTable && (
                <div>
                  {useTotal ? (
                    sub.length > 0 && (
                      <NewButton
                        icon={open ? 'faChevronUp' : 'faChevronDown'}
                        iconBtn
                        onClick={(e) => setOpen(!open)}
                        className={classes.expandRow}
                        disableRipple
                      />
                    )
                  ) : (
                    <NewButton
                      icon={open ? 'faChevronUp' : 'faChevronDown'}
                      iconBtn
                      onClick={(e) =>
                        sub.length === 0 &&
                        typeof dataDetailReqPromise === 'function'
                          ? handleExpendClick()
                          : setOpen(!open)
                      }
                      className={classes.expandRow}
                      disableRipple
                      style={{ backgroundColor: '#fff' }}
                    />
                  )}
                </div>
              )}
            </div>
          </TableCell>
        ) : null}
        {makeCell()}
      </TableRow>
      {expandTable && open && <>{makeSubCell()}</>}
    </>
  );
};

export default React.memo(withRouter(MbTableRow));
